module.exports = __webpack_public_path__ + "img/card-background-third.f9790830.png";